/**
 * Shared Billing Admin dialog styling. Extracted from BillingAdmin.js so the
 * entitlement grant/code dialogs match the Connect + Bulk Repoint modals exactly.
 */

/** Fixed width for every Billing Admin dialog (form + confirm). */
export const DIALOG_WIDTH_PX = 720;

export const DIALOG_PAPER_SX = {
  borderRadius: '12px',
  overflow: 'hidden',
  width: DIALOG_WIDTH_PX,
  maxWidth: DIALOG_WIDTH_PX,
};

export const DIALOG_CONTENT_SX = {
  px: 3,
  pt: 3.5,
  pb: 2.5,
  maxHeight: '70vh',
  overflowY: 'auto',
};

export const DIALOG_ACTIONS_SX = {
  px: 3,
  py: 2,
  borderTop: '1px solid #E0E0E0',
  backgroundColor: '#FAFAFA',
  gap: 1,
};

export const FIELD_CONFIG = { uiStyle: 'field_styling_25', fullWidth: true };

/** ISO date (YYYY-MM-DD or ISO string) → dd/MM/yyyy for StandardInputField date. */
export const isoToDisplayDate = (iso) => {
  if (!iso) return '';
  const part = String(iso).split('T')[0];
  const [y, m, d] = part.split('-');
  if (!y || !m || !d) return '';
  return `${d}/${m}/${y}`;
};

/** dd/MM/yyyy → Date or null. */
export const parseDisplayDate = (display) => {
  if (!display) return null;
  const parts = String(display).split('/');
  if (parts.length !== 3) return null;
  const [dd, mm, yyyy] = parts.map((p) => parseInt(p, 10));
  const d = new Date(yyyy, mm - 1, dd);
  return Number.isNaN(d.getTime()) ? null : d;
};
